import { ListService } from './list';
import _ from 'lodash';
export const SLOT_NAME_PREFIX = 'slot:';
export function getSlotName(str) {
    if (typeof str !== 'string')
        return '';
    const namespace = SLOT_NAME_PREFIX;
    return str.indexOf(namespace) === 0 ? str.replace(namespace, '') : '';
}
export function getSlotNames(items) {
    const slotNames = [];
    if (typeof items === 'string') {
        const name = getSlotName(items);
        if (name)
            slotNames.push(name);
        return slotNames;
    }
    return items.map(ListService.normalize)
        .filter(item => _.startsWith(item.label, SLOT_NAME_PREFIX))
        .map(item => { var _a; return (_a = item.label) === null || _a === void 0 ? void 0 : _a.replace(SLOT_NAME_PREFIX, ''); });
}
//# sourceMappingURL=utils.js.map